import styled from "styled-components";

export const StyledStorybook = styled.div`
  width: 320px;
  background-color: var(--white);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  text-align: left;
  position: relative;

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    .dots-holder {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 5px;

      .dot {
        width: 10px;
        height: 10px;
        background: var(--gray-150);
        border-radius: 50%;

        &.active {
          background: var(--blue);
        }
      }
    }
  }

  .skip-button {
    position: absolute;
    top: 12px;
    right: 12px;
    color: #666;
  }

  .footer-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .back-button,
  .next-button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .next-button {
    &.finish-button {
      padding: 4px 6px;
      background: var(--blue);
      color: var(--white);
      border-radius: 4px;
    }
  }

  .back-button--enabled svg,
  .next-button--enabled svg {
    color: var(--blue);
  }
`;

export const StyledTooltipContent = styled.div`
  margin: 0 0 14px;
  .tour-title {
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    color: #000;
    margin: 0 0 8px 0;
  }

  .tour-description {
    font-size: 14px;
    color: var(--light-gray);
    margin: 0;
    line-height: 1.5;
  }
`;
